import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class DepreciationInfo  {
    _originalTypeClassName = "zERP.BO.DepreciationInfo";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
DepreciationInfo.translate = translateService;
}
this.DepreciationValue = null;
this.AccumulatedDepreciationValue = null;
this.DepreciationInfoKey = null;
this._key = this.DepreciationInfoKey = 0; 
}

static translate: TranslateService;
_key: any;
DepreciationValue:any;
AccumulatedDepreciationValue:any;
private _DepreciationInfoKey:any;
get DepreciationInfoKey(): any {
    return this._DepreciationInfoKey;
  }
set DepreciationInfoKey(value: any) {
    this._DepreciationInfoKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.DepreciationInfoKey == null || $this.DepreciationInfoKey == 0;
            }


}